import { cn } from '@anytag/shared-utils';
import { CircularProgress } from './CircularProgress';

interface WithLoadingOverlayProps {
  children: React.ReactNode;
  loading: boolean;
  className?: string;
}
export const WithLoadingOverlay = ({ loading, children, className }: WithLoadingOverlayProps) => (
  <div className={cn('relative min-h-100 w-full', className)}>
    {loading ? (
      <div className={cn('absolute inset-0 z-1000 flex h-full w-full bg-white opacity-50')}>
        <CircularProgress size={48} thickness={0.5} className="m-auto bg-black-30" />
      </div>
    ) : null}
    {children}
  </div>
);
